export const blockIconsFileCloudSync = (
	<span className='material-symbols-outlined'>cloud_sync</span>
);
